import type { ReactNode } from 'react'

export function ListHeaderSeparator(): ReactNode {
  return <div className="h-4 w-[0.5px] bg-border" />
}
